import { LicenseType } from 'features/licenses/types'
import MobileLabelLine from 'components/MobileWhiteCardLine'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { useAppSelector } from 'app/hooks'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'

import LicenseStatuses from '../LicenseStatuses'
import CopyCode from './CopyCode'
import {
  LicensesMobileCopyCodeWrapper,
  LicensesUsedCodesMobileContainer,
} from './styles'
import LicensesHomeLinkCell from './LicensesHomeLinkCell'
import Note from './Note'

interface LicensesUsedCodesMobileProps {
  values: Record<string, any>
  original: LicenseType
}

/**
 * @todo localization
 */

function LicensesUsedCodesMobile({ original }: LicensesUsedCodesMobileProps) {
  const currentRootId = useAppSelector(currentRootDomainIdSelector)

  return (
    <LicensesUsedCodesMobileContainer>
      <LicensesMobileCopyCodeWrapper>
        <CopyCode code={original.code} />
        <LicenseStatuses license={original} rootDomainId={currentRootId} />
      </LicensesMobileCopyCodeWrapper>
      <MobileLabelLine label="Savant Order" value={original.orderNumber} />
      <MobileLabelLine label="Purchase Order" value={original.customerPO} />
      <MobileLabelLine
        label="Activated"
        value={
          <IntlFormattedDate
            date={original.created}
            withTime
            defaultReturn="-"
          />
        }
      />
      <MobileLabelLine
        label="Home"
        value={
          <LicensesHomeLinkCell
            homeId={original.homeId}
            homeName={original.homeName}
            homeRootDomainId={original.homeRootDomainId || ''}
          />
        }
      />
      <Note original={original} />
    </LicensesUsedCodesMobileContainer>
  )
}

export default LicensesUsedCodesMobile
